// import PropTypes from "prop-types";
// import React, { useEffect, useState } from "react";
// import logolight from "../../assets/images/logo.png";
// import logodark from "../../assets/images/logo.png";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

// import {
//   Row,
//   Col,
//   CardBody,
//   Card,
//   Alert,
//   Container,
//   Form,
//   Input,
//   FormFeedback,
//   Label,
//   InputGroup, InputGroupText
// } from "reactstrap";

// //redux
// import { useSelector, useDispatch } from "react-redux";

// import { Link } from "react-router-dom";
// import withRouter from "../../components/Common/withRouter";

// // Formik validation
// import * as Yup from "yup";
// import { useFormik } from "formik";

// // actions
// import { loginUser, socialLogin } from "../../store/actions";

// import { createSelector } from "reselect";

// const Login = (props) => {
//   document.title = "Hospital";
//   const [showPassword, setShowPassword] = useState(false);
//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   }
//   const dispatch = useDispatch();

//   const validation = useFormik({
//     // enableReinitialize : use this flag when initial values needs to be changed
//     enableReinitialize: true,

//     // initialValues: {
//     //   email: "admin@lincqualityhub.com" || "",
//     //   password: "123456" || "",
//     // },
//     initialValues: {
//       email: "",
//       password: "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().required("Please Enter Your Email"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),
//     onSubmit: (values) => {
//       dispatch(loginUser(values, props.router.navigate));
//     },
//   });

//   const loginpage = createSelector(
//     (state) => state.login,
//     (state) => ({
//       error: state.error,
//     })
//   );
//   // Inside your component
//   const { error } = useSelector(loginpage);

//   // handleValidSubmit
//   // const handleValidSubmit = (event, values) => {
//   //   dispatch(loginUser(values, props.router.navigate));
//   // };

//   useEffect(() => {
//     document.body.className = "bg-pattern";
//     // remove classname when component will unmount
//     return function cleanup() {
//       document.body.className = "";
//     };
//   });

//   return (
//     <React.Fragment>
//       <div className="bg-overlay"></div>
//       <div className="account-pages d-flex flex-column justify-content-center " style={{ height: '100vh' }}>
//         <Container>
//           <Row className=" g-2 justify-content-center">
//             <Col lg={6} md={8} xl={4}>
//               <Card>
//                 <CardBody className="p-4">
//                   <div>
//                     <div className="text-center">
//                       <Link to="/">
//                         <img
//                           src={logodark}
//                           alt=""
//                           className="auth-logo logo-dark mx-auto"
//                           style={{ width: '150px' }}
//                         />
//                         <img
//                           src={logolight}
//                           alt=""
//                           className="auth-logo logo-light mx-auto"
//                           style={{ width: '150px' }}
//                         />
//                       </Link>
//                     </div>
//                     <h4 className="font-size-18 text-muted mt-2 text-center">
//                       Welcome
//                     </h4>
//                     {/* <p className="mb-3 text-center">
//                       Sign in to continue to Hospital.
//                     </p> */}
//                     <Form
//                       className="form-horizontal"
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         validation.handleSubmit();
//                         return false;
//                       }}
//                     >
//                       {error ? (
//                         <Alert color="danger">
//                           <div>{error}</div>
//                         </Alert>
//                       ) : null}
//                       <Row>
//                         <Col md={12}>
//                           <div className="mb-4">
//                             <Label className="form-label">User Name</Label>
//                             <Input
//                               name="email"
//                               className="form-control"
//                               placeholder="Enter email"
//                               type="text"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.email || ""}
//                               invalid={
//                                 validation.touched.email &&
//                                   validation.errors.email
//                                   ? true
//                                   : false
//                               }
//                             />
//                             {validation.touched.email &&
//                               validation.errors.email ? (
//                               <FormFeedback type="invalid">
//                                 <div>{validation.errors.email}</div>
//                               </FormFeedback>
//                             ) : null}
//                           </div>
//                           <div className="mb-4">
//                             <Label className="form-label">Password</Label>

//                             <InputGroup>
//                               <Input
//                                 name="password"
//                                 value={validation.values.password || ""}
//                                 type={showPassword ? "text" : "password"}
//                                 placeholder="Enter Password"
//                                 onChange={validation.handleChange}
//                                 onBlur={validation.handleBlur}
//                                 invalid={
//                                   validation.touched.password && validation.errors.password
//                                     ? true
//                                     : false
//                                 }
//                               />
//                               <InputGroupText onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
//                                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//                               </InputGroupText>
//                               {validation.touched.password && validation.errors.password ? (
//                                 <FormFeedback type="invalid">
//                                   {validation.errors.password}
//                                 </FormFeedback>
//                               ) : null}
//                             </InputGroup>

//                           </div>

//                           <Row>
//                             {/* <Col>
//                               <div className="form-check">
//                                 <input
//                                   type="checkbox"
//                                   className="form-check-input"
//                                   id="customControlInline"
//                                 />
//                                 <label
//                                   className="form-label form-check-label"
//                                   htmlFor="customControlInline"
//                                 >
//                                   Remember me
//                                 </label>
//                               </div>
//                             </Col> */}
//                             {/* <Col className="col-7">
//                               <div className="text-md-end mt-3 mt-md-0">
//                                 <Link
//                                   to="/auth-recoverpw"
//                                   className="text-muted"
//                                 >
//                                   <i className="mdi mdi-lock"></i> Forgot your
//                                   password?
//                                 </Link>
//                               </div>
//                             </Col> */}
//                           </Row>
//                           <div className="d-grid mt-4">
//                             <button
//                               className="btn btn-primary waves-effect waves-light"
//                               type="submit"
//                             >
//                               Log In
//                             </button>
//                           </div>

//                         </Col>
//                       </Row>
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>
//               <div className="mt-5 text-center">
//                 {/* <p className="text-white-50">
//                 Don't have an account ?{" "}
//                 <Link to="/register" className="fw-medium text-primary">
//                   {" "}
//                   Register{" "}
//                 </Link>{" "}
//               </p> */}
//                 {/* <p className="text-white-50">
//                   © {new Date().getFullYear()} Hospital Designed by{" "}
//                   <a href="https://capdigisoft.com/" target="_blanck">
//                     {" "}
//                     CAP Digisoft
//                   </a>
//                 </p> */}
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// export default withRouter(Login);

// Login.propTypes = {
//   history: PropTypes.object,
// };

import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import logolight from "../../assets/images/logo.png";
import logodark from "../../assets/images/logo.png";
import Logo from "../../assets/images/custom/attestaai-logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroup,
  InputGroupText,
} from "reactstrap";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

import * as Yup from "yup";
import { useFormik } from "formik";
import { API_URL, IMAGE_URL } from "../../global";

const Login = (props) => {
  document.title = "Dental Kiosk";
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setError(null);
      
      try {

        console.log("test:",API_URL)
        const response = await fetch(`${API_URL}/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: values.email,
            password: values.password,
          }),
        });

        const data = await response.json();

        console.log(data);

        // if (!response.ok) {
        //   throw new Error(data.message || "Invalid credentials");
        // }
        //sessionStorage.setItem("token", data.token);
        //props.router.navigate("/dashboard");

        if (data.is_valid === 1) {
          sessionStorage.setItem("token", data.token);
          sessionStorage.setItem("user_id", data.user_id);   
          props.router.navigate("/dashboard");
        } else if (data.is_valid === 2) {
          throw new Error(data.message || "Invalid password");
        } else if (data.is_valid === 3) {
          throw new Error(data.message || "User not found");
        } else {
          throw new Error("Unexpected error");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    document.body.className = "bg-pattern";
    return () => {
      document.body.className = "";
    };
  }, []);

  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div
        className="account-pages d-flex flex-column justify-content-center"
        style={{ height: "100vh" }}
      >
        <Container>
          <Row className="g-2 justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center">
                    <Link to="/">
                      <img
                        src={Logo}
                        alt="Logo"
                        className="auth-logo mx-auto"
                        style={{ width: "150px" }}
                      />
                    </Link>
                  </div>
                  <h4 className="font-size-18 text-muted mt-2 text-center">
                    Welcome
                  </h4>

                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    {error && <Alert color="danger">{error}</Alert>}

                    <Row>
                      <Col md={12}>
                        <div className="mb-4">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            type="text"
                            placeholder="Enter email"
                            value={validation.values.email}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email && (
                              <FormFeedback>
                                {validation.errors.email}
                              </FormFeedback>
                            )}
                        </div>

                        <div className="mb-4">
                          <Label className="form-label">Password</Label>
                          <InputGroup>
                            <Input
                              name="password"
                              type={showPassword ? "text" : "password"}
                              placeholder="Enter Password"
                              value={validation.values.password}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            <InputGroupText
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </InputGroupText>
                          </InputGroup>
                          {validation.touched.password &&
                            validation.errors.password && (
                              <FormFeedback>
                                {validation.errors.password}
                              </FormFeedback>
                            )}
                        </div>

                        <div className="d-grid mt-4">
                          <button
                            className="btn"
                            type="submit"
                            disabled={loading}
                            style={{
                              backgroundColor: "rgb(34, 106, 184)",
                              color: "white", // optional: makes text readable
                              border: "none",
                            }}
                          >
                            {loading ? "Logging in..." : "Log In"}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  router: PropTypes.object,
};
